<template>
  <b-container
    class="m-2 study-element"
    fluid
  >
    <b-row class="title-section mx-0 my-3">
      <SimpleTextInputConfiguration
        :controller="LegendCrtller"
        classname="main-name-input px-0"
        class="w-100"
      />
    </b-row>
    <b-row class="m-0">
      <b-container
        class="m-0"
        fluid
      >
        <StateSelector :sectionconfig="sectionconfig" />
        <b-row
          v-if="isVisibleReverseCurrent"
          class="text-center title-subsection mr-1 mt-2"
        >
          <p>Configuration</p>
        </b-row>
        <b-row
          v-if="isVisibleReverseCurrent"
          class="pl-2"
        >
          <p class="m-0 p-0 extra-message">
            Reverse current detected in files
          </p>
        </b-row>
        <b-row
          v-if="isVisibleReverseCurrent"
          class="m-0 p-0"
        >
          <DropdownConfiguration :controller="ReverseCurrentCtller" />
        </b-row>
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Axis</p>
        </b-row>
        <HeaderConfiguration />
        <TimeConfiguration
          axis="X"
          :sectionconfig="sectionconfig"
        />
        <CurrentConfiguration
          axis="Y"
          :sectionconfig="sectionconfig"
        />
        <PreprocessingSelection :sectionconfig="sectionconfig" />
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Analysiss</p>
        </b-row>
        <MultiMeanFit :sectionconfig="sectionconfig" />
        <FeatureCheckWrapper :sectionconfig="sectionconfig" />
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Extra Configuration</p>
        </b-row>
        <ExcludeConcentrations :sectionconfig="sectionconfig" />
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import DropdownConfiguration from '../elements/DropdownConfiguration'
import ExcludeConcentrations from '../elements/ExcludeConcentrations'
import FeatureCheckWrapper from '@/components/properties/specificFeatures/FeatureCheckWrapper'
import StateSelector from '@/components/properties/specificFeatures/StateSelector'
import SimpleTextInputConfiguration from '@/components/properties/elements/SimpleTextInputConfiguration'
import MultiMeanFit from '@/components/properties/elements/fit/MultiMeanFit'
import TimeConfiguration from '../units/TimeConfiguration'
import HeaderConfiguration from '../units/HeaderConfiguration'
import CurrentConfiguration from '../units/CurrentConfiguration'
import {fixedConfCtrller,comboBoxConfCtrller,simpleInputTextConfCtrller} from '@/assets/classes/configuration.js'
import { PlotType } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, ConfigName, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import PreprocessingSelection from '../elements/preprocessing/PreprocessingSelection'
import { mapGetters } from 'vuex'

const rootContextFolder='ReportViewer/Studies/AC/'

export default {
  name: 'ContinuousStudyAC',
  components:{
    DropdownConfiguration,
    PreprocessingSelection,
    ExcludeConcentrations,
    HeaderConfiguration,
    TimeConfiguration,
    CurrentConfiguration,
    MultiMeanFit,
    FeatureCheckWrapper,
    StateSelector,
    SimpleTextInputConfiguration
  },
  props: { 
    sectionconfig:{
      type:String,
      required: true
    },
    typestudy:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      elementsConfig: [],
      LegendCrtller: new simpleInputTextConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.legendStudy}`,'', ''),
      typeXaxisCrtller: new fixedConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.xAxisType}`,''),
      typeYaxisCrtller: new fixedConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.yAxisType}`,''),
      ReverseCurrentCtller: new comboBoxConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.CurrentDirectionReverse}`,[
          {text:'Forward',value:'Forward_Current'},
          {text:'Reverse',value:'Reverse_Current'},
          {text:'Difference',value:'Difference_Current'}
        ],'Current Direction',0,rootContextFolder+'ReverseCurrent'
      ),
      title:'',
      isVisibleReverseCurrent:false
    }
  },
  computed:mapGetters(['getCurrentReportViewer']),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.configureStudy()
    this.isVisibleReverseCurrent = typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent])!=='undefined' && this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent]
  },
  methods: {
    configureStudy(){
      this.elementsConfig = [
        this.LegendCrtller,
        this.typeXaxisCrtller,
        this.typeYaxisCrtller,
        this.ReverseCurrentCtller
      ]
      this.typeXaxisCrtller.value = PlotType[this.typestudy].xAxisType
      this.typeYaxisCrtller.value = PlotType[this.typestudy].yAxisType
      this.title = PlotType[this.typestudy].text.replace(this.typestudy, this.sectionconfig)
      this.LegendCrtller.defaultValue=this.title
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
    }
  }
}
</script>

<style lang="scss" scoped>
.expanded-info{
  background-color: #DDD;
  border-radius: 5px;
}
.range-display{
  font-weight: bold;
  text-align: center;
  font-size: 0.8;
}
.extra-message{
  font-weight:lighter;
}
::v-deep .main-name-input {
  font-size: 1rem;
  font-weight: bold;
  background-color: transparent;
  border: 0px solid;
}
</style>